(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-coroutines-core.js', './kotlinx-atomicfu.js', './ktor-ktor-http.js', './ktor-ktor-client-core.js', './ktor-ktor-io.js', './ktor-ktor-utils.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-coroutines-core.js'), require('./kotlinx-atomicfu.js'), require('./ktor-ktor-http.js'), require('./ktor-ktor-client-core.js'), require('./ktor-ktor-io.js'), require('./ktor-ktor-utils.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-logging'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ktor-ktor-client-logging'.");
    }
    if (typeof this['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-logging'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'ktor-ktor-client-logging'.");
    }
    if (typeof this['kotlinx-atomicfu'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-logging'. Its dependency 'kotlinx-atomicfu' was not found. Please, check whether 'kotlinx-atomicfu' is loaded prior to 'ktor-ktor-client-logging'.");
    }
    if (typeof this['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-logging'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'ktor-ktor-client-logging'.");
    }
    if (typeof this['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-logging'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'ktor-ktor-client-logging'.");
    }
    if (typeof this['ktor-ktor-io'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-logging'. Its dependency 'ktor-ktor-io' was not found. Please, check whether 'ktor-ktor-io' is loaded prior to 'ktor-ktor-client-logging'.");
    }
    if (typeof this['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-logging'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'ktor-ktor-client-logging'.");
    }
    root['ktor-ktor-client-logging'] = factory(typeof this['ktor-ktor-client-logging'] === 'undefined' ? {} : this['ktor-ktor-client-logging'], this['kotlin-kotlin-stdlib'], this['kotlinx-coroutines-core'], this['kotlinx-atomicfu'], this['ktor-ktor-http'], this['ktor-ktor-client-core'], this['ktor-ktor-io'], this['ktor-ktor-utils']);
  }
}(globalThis, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_org_jetbrains_kotlinx_atomicfu, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_client_core, kotlin_io_ktor_ktor_io, kotlin_io_ktor_ktor_utils) {
  'use strict';
  //region block: imports
  var CoroutineImpl = kotlin_kotlin.$_$.j9;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.v8;
  var THROW_CCE = kotlin_kotlin.$_$.oe;
  var isCharSequence = kotlin_kotlin.$_$.ra;
  var trim = kotlin_kotlin.$_$.xd;
  var toString = kotlin_kotlin.$_$.lb;
  var Unit_instance = kotlin_kotlin.$_$.d5;
  var protoOf = kotlin_kotlin.$_$.hb;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.ja;
  var charSequenceLength = kotlin_kotlin.$_$.v9;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.d1;
  var Job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.z;
  var atomic$boolean$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.b;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.m2;
  var initMetadataForClass = kotlin_kotlin.$_$.ha;
  var VOID = kotlin_kotlin.$_$.g;
  var Enum = kotlin_kotlin.$_$.ee;
  var ReadChannelContent = kotlin_io_ktor_ktor_http.$_$.n;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ia;
  var println = kotlin_kotlin.$_$.n9;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.l;
  var Phases_getInstance = kotlin_io_ktor_ktor_client_core.$_$.d;
  var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.p;
  var Url = kotlin_io_ktor_ktor_http.$_$.y;
  var HttpHeaders_getInstance = kotlin_io_ktor_ktor_http.$_$.e;
  var toString_0 = kotlin_kotlin.$_$.pf;
  var charset = kotlin_io_ktor_ktor_http.$_$.c1;
  var Charsets_getInstance = kotlin_io_ktor_ktor_io.$_$.g;
  var ByteChannel = kotlin_io_ktor_ktor_io.$_$.f1;
  var GlobalScope_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.k;
  var Dispatchers_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i1;
  var Phases_getInstance_0 = kotlin_io_ktor_ktor_client_core.$_$.e;
  var Phases_getInstance_1 = kotlin_io_ktor_ktor_client_core.$_$.f;
  var Plugin_getInstance = kotlin_io_ktor_ktor_client_core.$_$.b;
  var ResponseObserver = kotlin_io_ktor_ktor_client_core.$_$.h;
  var AttributeKey = kotlin_io_ktor_ktor_utils.$_$.m;
  var HttpClientPlugin = kotlin_io_ktor_ktor_client_core.$_$.i;
  var Collection = kotlin_kotlin.$_$.g5;
  var isInterface = kotlin_kotlin.$_$.va;
  var PipelineContext = kotlin_io_ktor_ktor_utils.$_$.h;
  var initMetadataForLambda = kotlin_kotlin.$_$.la;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y;
  var readText = kotlin_io_ktor_ktor_io.$_$.z;
  var HttpResponse = kotlin_io_ktor_ktor_client_core.$_$.r;
  var HttpResponseContainer = kotlin_io_ktor_ktor_client_core.$_$.q;
  var contentType = kotlin_io_ktor_ktor_http.$_$.f1;
  var emptyList = kotlin_kotlin.$_$.s6;
  var toList = kotlin_kotlin.$_$.l8;
  var sortedWith = kotlin_kotlin.$_$.h8;
  var joinToString = kotlin_kotlin.$_$.i7;
  var compareValues = kotlin_kotlin.$_$.t8;
  var writer = kotlin_io_ktor_ktor_io.$_$.l1;
  var WriterScope = kotlin_io_ktor_ktor_io.$_$.i1;
  var close = kotlin_io_ktor_ktor_io.$_$.k1;
  var copyToBoth = kotlin_io_ktor_ktor_utils.$_$.w;
  var WriteChannelContent = kotlin_io_ktor_ktor_http.$_$.o;
  var writeFully = kotlin_io_ktor_ktor_io.$_$.d;
  var ByteArrayContent = kotlin_io_ktor_ktor_http.$_$.k;
  //endregion
  //region block: pre-declaration
  initMetadataForCoroutine($logResponseExceptionCOROUTINE$0, CoroutineImpl);
  initMetadataForCoroutine($logResponseBodyCOROUTINE$1, CoroutineImpl);
  initMetadataForCoroutine($closeResponseLogCOROUTINE$2, CoroutineImpl);
  initMetadataForClass(HttpClientCallLogger, 'HttpClientCallLogger', VOID, VOID, VOID, [1, 0]);
  initMetadataForClass(LogLevel, 'LogLevel', VOID, Enum);
  initMetadataForClass(LoggedContent, 'LoggedContent', VOID, ReadChannelContent);
  initMetadataForCompanion(Companion);
  initMetadataForClass(SimpleLogger, 'SimpleLogger', SimpleLogger);
  initMetadataForClass(Config, 'Config', Config);
  initMetadataForCompanion(Companion_0, VOID, [HttpClientPlugin]);
  initMetadataForLambda(Logging$setupRequestLogging$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(Logging$logRequestBody$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(Logging$setupResponseLogging$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(Logging$setupResponseLogging$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(Logging$setupResponseLogging$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForClass(Logging, 'Logging', VOID, VOID, VOID, [1, 2]);
  initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0');
  initMetadataForCoroutine($logResponseBodyCOROUTINE$4, CoroutineImpl);
  initMetadataForLambda(toReadChannel$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($observeCOROUTINE$5, CoroutineImpl);
  //endregion
  function $logResponseExceptionCOROUTINE$0(_this__u8e3s4, message, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.c4w_1 = _this__u8e3s4;
    this.d4w_1 = message;
  }
  protoOf($logResponseExceptionCOROUTINE$0).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            this.j8_1 = 1;
            suspendResult = this.c4w_1.h4w_1.nr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = this.d4w_1;
            this.c4w_1.e4w_1.l4w(toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE())));
            return Unit_instance;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function $logResponseBodyCOROUTINE$1(_this__u8e3s4, message, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u4w_1 = _this__u8e3s4;
    this.v4w_1 = message;
  }
  protoOf($logResponseBodyCOROUTINE$1).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            this.j8_1 = 1;
            suspendResult = this.u4w_1.i4w_1.nr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.u4w_1.g4w_1.o7(this.v4w_1);
            return Unit_instance;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function $closeResponseLogCOROUTINE$2(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.e4x_1 = _this__u8e3s4;
  }
  protoOf($closeResponseLogCOROUTINE$2).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            if (!this.e4x_1.k4w_1.atomicfu$compareAndSet(false, true))
              return Unit_instance;
            this.j8_1 = 1;
            suspendResult = this.e4x_1.h4w_1.nr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var message = toString(trim(this.e4x_1.g4w_1));
            if (charSequenceLength(message) > 0) {
              this.e4x_1.e4w_1.l4w(message);
            }

            return Unit_instance;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function HttpClientCallLogger(logger) {
    this.e4w_1 = logger;
    this.f4w_1 = StringBuilder_init_$Create$();
    this.g4w_1 = StringBuilder_init_$Create$();
    this.h4w_1 = Job();
    this.i4w_1 = Job();
    this.j4w_1 = atomic$boolean$1(false);
    this.k4w_1 = atomic$boolean$1(false);
  }
  protoOf(HttpClientCallLogger).f4x = function (message) {
    // Inline function 'kotlin.text.appendLine' call
    var this_0 = this.f4w_1;
    // Inline function 'kotlin.text.trim' call
    var value = toString(trim(isCharSequence(message) ? message : THROW_CCE()));
    // Inline function 'kotlin.text.appendLine' call
    this_0.o7(value).p7(_Char___init__impl__6a9atx(10));
  };
  protoOf(HttpClientCallLogger).g4x = function (message) {
    // Inline function 'kotlin.text.appendLine' call
    var this_0 = this.g4w_1;
    // Inline function 'kotlin.text.trim' call
    var value = toString(trim(isCharSequence(message) ? message : THROW_CCE()));
    // Inline function 'kotlin.text.appendLine' call
    this_0.o7(value).p7(_Char___init__impl__6a9atx(10));
    this.i4w_1.mr();
  };
  protoOf(HttpClientCallLogger).h4x = function (message, $completion) {
    var tmp = new $logResponseExceptionCOROUTINE$0(this, message, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpClientCallLogger).i4x = function (message, $completion) {
    var tmp = new $logResponseBodyCOROUTINE$1(this, message, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpClientCallLogger).j4x = function () {
    if (!this.j4w_1.atomicfu$compareAndSet(false, true))
      return Unit_instance;
    try {
      var message = toString(trim(this.f4w_1));
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(message) > 0) {
        this.e4w_1.l4w(message);
      }
    }finally {
      this.h4w_1.mr();
    }
  };
  protoOf(HttpClientCallLogger).k4x = function ($completion) {
    var tmp = new $closeResponseLogCOROUTINE$2(this, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  var LogLevel_ALL_instance;
  var LogLevel_HEADERS_instance;
  var LogLevel_BODY_instance;
  var LogLevel_INFO_instance;
  var LogLevel_NONE_instance;
  var LogLevel_entriesInitialized;
  function LogLevel_initEntries() {
    if (LogLevel_entriesInitialized)
      return Unit_instance;
    LogLevel_entriesInitialized = true;
    LogLevel_ALL_instance = new LogLevel('ALL', 0, true, true, true);
    LogLevel_HEADERS_instance = new LogLevel('HEADERS', 1, true, true, false);
    LogLevel_BODY_instance = new LogLevel('BODY', 2, true, false, true);
    LogLevel_INFO_instance = new LogLevel('INFO', 3, true, false, false);
    LogLevel_NONE_instance = new LogLevel('NONE', 4, false, false, false);
  }
  function LogLevel(name, ordinal, info, headers, body) {
    Enum.call(this, name, ordinal);
    this.n4x_1 = info;
    this.o4x_1 = headers;
    this.p4x_1 = body;
  }
  function LogLevel_HEADERS_getInstance() {
    LogLevel_initEntries();
    return LogLevel_HEADERS_instance;
  }
  function LogLevel_NONE_getInstance() {
    LogLevel_initEntries();
    return LogLevel_NONE_instance;
  }
  function LoggedContent(originalContent, channel) {
    ReadChannelContent.call(this);
    this.r4x_1 = originalContent;
    this.s4x_1 = channel;
    this.t4x_1 = this.r4x_1.t3n();
    this.u4x_1 = this.r4x_1.v3n();
    this.v4x_1 = this.r4x_1.u3n();
    this.w4x_1 = this.r4x_1.p3i();
  }
  protoOf(LoggedContent).t3n = function () {
    return this.t4x_1;
  };
  protoOf(LoggedContent).v3n = function () {
    return this.u4x_1;
  };
  protoOf(LoggedContent).u3n = function () {
    return this.v4x_1;
  };
  protoOf(LoggedContent).p3i = function () {
    return this.w4x_1;
  };
  protoOf(LoggedContent).z3n = function () {
    return this.s4x_1;
  };
  function Companion() {
  }
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function get_SIMPLE(_this__u8e3s4) {
    return new SimpleLogger();
  }
  function SimpleLogger() {
  }
  protoOf(SimpleLogger).l4w = function (message) {
    println('HttpClient: ' + message);
  };
  function get_ClientCallLogger() {
    _init_properties_Logging_kt__66pui5();
    return ClientCallLogger;
  }
  var ClientCallLogger;
  function get_DisableLogging() {
    _init_properties_Logging_kt__66pui5();
    return DisableLogging;
  }
  var DisableLogging;
  function Config() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.x4x_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.y4x_1 = ArrayList_init_$Create$();
    this.z4x_1 = null;
    this.a4y_1 = LogLevel_HEADERS_getInstance();
  }
  protoOf(Config).b4y = function (value) {
    this.z4x_1 = value;
  };
  protoOf(Config).c4y = function () {
    var tmp0_elvis_lhs = this.z4x_1;
    return tmp0_elvis_lhs == null ? get_DEFAULT(Companion_instance) : tmp0_elvis_lhs;
  };
  function setupRequestLogging($this, client) {
    var tmp = Phases_getInstance().s3u_1;
    client.c3s_1.t3b(tmp, Logging$setupRequestLogging$slambda_0($this, null));
  }
  function logRequest($this, request, $completion) {
    var tmp = request.d3u_1;
    var content = tmp instanceof OutgoingContent ? tmp : THROW_CCE();
    var logger = new HttpClientCallLogger($this.d4y_1);
    request.f3u_1.s34(get_ClientCallLogger(), logger);
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.client.plugins.logging.Logging.logRequest.<anonymous>' call
    if ($this.e4y_1.n4x_1) {
      // Inline function 'kotlin.text.appendLine' call
      var value = 'REQUEST: ' + Url(request.a3u_1).toString();
      // Inline function 'kotlin.text.appendLine' call
      this_0.o7(value).p7(_Char___init__impl__6a9atx(10));
      // Inline function 'kotlin.text.appendLine' call
      var value_0 = 'METHOD: ' + request.b3u_1.toString();
      // Inline function 'kotlin.text.appendLine' call
      this_0.o7(value_0).p7(_Char___init__impl__6a9atx(10));
    }
    if ($this.e4y_1.o4x_1) {
      // Inline function 'kotlin.text.appendLine' call
      var value_1 = 'COMMON HEADERS';
      // Inline function 'kotlin.text.appendLine' call
      this_0.o7(value_1).p7(_Char___init__impl__6a9atx(10));
      logHeaders(this_0, request.c3u_1.n38(), $this.g4y_1);
      // Inline function 'kotlin.text.appendLine' call
      var value_2 = 'CONTENT HEADERS';
      // Inline function 'kotlin.text.appendLine' call
      this_0.o7(value_2).p7(_Char___init__impl__6a9atx(10));
      var tmp$ret$9;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = $this.g4y_1.g();
        while (tmp0_iterator.h()) {
          var element = tmp0_iterator.i();
          // Inline function 'io.ktor.client.plugins.logging.Logging.logRequest.<anonymous>.<anonymous>' call
          if (element.i4y_1(HttpHeaders_getInstance().b3f_1)) {
            tmp$ret$9 = element;
            break $l$block;
          }
        }
        tmp$ret$9 = null;
      }
      var tmp0_safe_receiver = tmp$ret$9;
      var contentLengthPlaceholder = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h4y_1;
      var tmp$ret$11;
      $l$block_0: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator_0 = $this.g4y_1.g();
        while (tmp0_iterator_0.h()) {
          var element_0 = tmp0_iterator_0.i();
          // Inline function 'io.ktor.client.plugins.logging.Logging.logRequest.<anonymous>.<anonymous>' call
          if (element_0.i4y_1(HttpHeaders_getInstance().e3f_1)) {
            tmp$ret$11 = element_0;
            break $l$block_0;
          }
        }
        tmp$ret$11 = null;
      }
      var tmp1_safe_receiver = tmp$ret$11;
      var contentTypePlaceholder = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.h4y_1;
      var tmp2_safe_receiver = content.v3n();
      if (tmp2_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0 = HttpHeaders_getInstance().b3f_1;
        logHeader(this_0, tmp_0, contentLengthPlaceholder == null ? tmp2_safe_receiver.toString() : contentLengthPlaceholder);
      }
      var tmp3_safe_receiver = content.t3n();
      if (tmp3_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1 = HttpHeaders_getInstance().e3f_1;
        logHeader(this_0, tmp_1, contentTypePlaceholder == null ? tmp3_safe_receiver.toString() : contentTypePlaceholder);
      }
      logHeaders(this_0, content.p3i().n38(), $this.g4y_1);
    }
    var message = this_0.toString();
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(message) > 0) {
      logger.f4x(message);
    }
    var tmp_2;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(message) === 0) {
      tmp_2 = true;
    } else {
      tmp_2 = !$this.e4y_1.p4x_1;
    }
    if (tmp_2) {
      logger.j4x();
      return null;
    }
    return logRequestBody($this, content, logger, $completion);
  }
  function logRequestBody($this, content, logger, $completion) {
    var requestLog = StringBuilder_init_$Create$();
    // Inline function 'kotlin.text.appendLine' call
    var value = 'BODY Content-Type: ' + toString_0(content.t3n());
    // Inline function 'kotlin.text.appendLine' call
    requestLog.o7(value).p7(_Char___init__impl__6a9atx(10));
    var tmp0_safe_receiver = content.t3n();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : charset(tmp0_safe_receiver);
    var charset_0 = tmp1_elvis_lhs == null ? Charsets_getInstance().w30_1 : tmp1_elvis_lhs;
    var channel = ByteChannel();
    var tmp = GlobalScope_instance;
    var tmp_0 = Dispatchers_getInstance().ov_1;
    var tmp_1 = launch(tmp, tmp_0, VOID, Logging$logRequestBody$slambda_0(channel, charset_0, requestLog, null));
    tmp_1.rk(Logging$logRequestBody$lambda(logger, requestLog));
    return observe(content, channel, $completion);
  }
  function logRequestException($this, context, cause) {
    if ($this.e4y_1.n4x_1) {
      $this.d4y_1.l4w('REQUEST ' + Url(context.a3u_1).toString() + ' failed with exception: ' + cause.toString());
    }
  }
  function setupResponseLogging($this, client) {
    var tmp = Phases_getInstance_0().c41_1;
    client.d3s_1.t3b(tmp, Logging$setupResponseLogging$slambda_0($this, null));
    var tmp_0 = Phases_getInstance_1().y3u_1;
    client.b3s_1.t3b(tmp_0, Logging$setupResponseLogging$slambda_2($this, null));
    if (!$this.e4y_1.p4x_1)
      return Unit_instance;
    var observer = Logging$setupResponseLogging$slambda_4($this, null);
    Plugin_getInstance().v4i(new ResponseObserver(observer), client);
  }
  function logResponseException($this, log, request, cause) {
    if (!$this.e4y_1.n4x_1)
      return Unit_instance;
    log.o7('RESPONSE ' + request.m3w().toString() + ' failed with exception: ' + cause.toString());
  }
  function Companion_0() {
    Companion_instance_0 = this;
    this.j4y_1 = new AttributeKey('ClientLogging');
  }
  protoOf(Companion_0).u = function () {
    return this.j4y_1;
  };
  protoOf(Companion_0).k4y = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    var config = this_0;
    return new Logging(config.c4y(), config.a4y_1, config.x4x_1, config.y4x_1);
  };
  protoOf(Companion_0).f3v = function (block) {
    return this.k4y(block);
  };
  protoOf(Companion_0).l4y = function (plugin, scope) {
    setupRequestLogging(plugin, scope);
    setupResponseLogging(plugin, scope);
  };
  protoOf(Companion_0).g3v = function (plugin, scope) {
    return this.l4y(plugin instanceof Logging ? plugin : THROW_CCE(), scope);
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function shouldBeLogged($this, request) {
    var tmp;
    if ($this.f4y_1.o()) {
      tmp = true;
    } else {
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var this_0 = $this.f4y_1;
        var tmp_0;
        if (isInterface(this_0, Collection)) {
          tmp_0 = this_0.o();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var tmp0_iterator = this_0.g();
        while (tmp0_iterator.h()) {
          var element = tmp0_iterator.i();
          // Inline function 'io.ktor.client.plugins.logging.Logging.shouldBeLogged.<anonymous>' call
          if (element(request)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      tmp = tmp$ret$0;
    }
    return tmp;
  }
  function Logging$setupRequestLogging$slambda(this$0, resultContinuation) {
    this.u4y_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Logging$setupRequestLogging$slambda).u3s = function ($this$intercept, it, $completion) {
    var tmp = this.v3s($this$intercept, it, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(Logging$setupRequestLogging$slambda).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.u3s(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(Logging$setupRequestLogging$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 8;
            if (!shouldBeLogged(this.u4y_1, this.v4y_1.p3b_1)) {
              this.v4y_1.p3b_1.f3u_1.s34(get_DisableLogging(), Unit_instance);
              return Unit_instance;
            }

            this.k8_1 = 2;
            this.j8_1 = 1;
            suspendResult = logRequest(this.u4y_1, this.v4y_1.p3b_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.x4y_1 = suspendResult;
            this.k8_1 = 8;
            this.j8_1 = 3;
            continue $sm;
          case 2:
            this.k8_1 = 8;
            var tmp_0 = this.m8_1;
            if (tmp_0 instanceof Error) {
              this.y4y_1 = this.m8_1;
              var tmp_1 = this;
              tmp_1.x4y_1 = null;
              this.j8_1 = 3;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 3:
            this.k8_1 = 8;
            this.z4y_1 = this.x4y_1;
            this.j8_1 = 4;
            continue $sm;
          case 4:
            this.k8_1 = 7;
            this.k8_1 = 6;
            this.j8_1 = 5;
            var tmp0_elvis_lhs = this.z4y_1;
            suspendResult = this.v4y_1.t3a(tmp0_elvis_lhs == null ? this.v4y_1.s3a() : tmp0_elvis_lhs, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var tmp_2 = this;
            tmp_2.a4z_1 = Unit_instance;
            this.k8_1 = 8;
            this.j8_1 = 9;
            continue $sm;
          case 6:
            this.k8_1 = 7;
            var tmp_3 = this.m8_1;
            if (tmp_3 instanceof Error) {
              var cause = this.m8_1;
              var tmp_4 = this;
              logRequestException(this.u4y_1, this.v4y_1.p3b_1, cause);
              throw cause;
            } else {
              throw this.m8_1;
            }

          case 7:
            this.k8_1 = 8;
            var t = this.m8_1;
            throw t;
          case 8:
            throw this.m8_1;
          case 9:
            this.k8_1 = 8;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 8) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(Logging$setupRequestLogging$slambda).v3s = function ($this$intercept, it, completion) {
    var i = new Logging$setupRequestLogging$slambda(this.u4y_1, completion);
    i.v4y_1 = $this$intercept;
    i.w4y_1 = it;
    return i;
  };
  function Logging$setupRequestLogging$slambda_0(this$0, resultContinuation) {
    var i = new Logging$setupRequestLogging$slambda(this$0, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.u3s($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Logging$logRequestBody$slambda($channel, $charset, $requestLog, resultContinuation) {
    this.j4z_1 = $channel;
    this.k4z_1 = $charset;
    this.l4z_1 = $requestLog;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Logging$logRequestBody$slambda).l17 = function ($this$launch, $completion) {
    var tmp = this.m17($this$launch, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(Logging$logRequestBody$slambda).m9 = function (p1, $completion) {
    return this.l17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Logging$logRequestBody$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            var tmp_0 = this;
            tmp_0.n4z_1 = this.j4z_1;
            var tmp_1 = this;
            tmp_1.o4z_1 = this.k4z_1;
            this.k8_1 = 2;
            this.j8_1 = 1;
            suspendResult = this.n4z_1.i2w(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.p4z_1 = readText(ARGUMENT, this.o4z_1);
            this.k8_1 = 3;
            this.j8_1 = 4;
            continue $sm;
          case 2:
            this.k8_1 = 3;
            var tmp_2 = this.m8_1;
            if (tmp_2 instanceof Error) {
              var cause = this.m8_1;
              var tmp_3 = this;
              tmp_3.p4z_1 = null;
              this.j8_1 = 4;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 3:
            throw this.m8_1;
          case 4:
            this.k8_1 = 3;
            var tmp0_elvis_lhs = this.p4z_1;
            var text = tmp0_elvis_lhs == null ? '[request body omitted]' : tmp0_elvis_lhs;
            var this_0 = this.l4z_1;
            var value = 'BODY START';
            this_0.o7(value).p7(_Char___init__impl__6a9atx(10));
            this.l4z_1.o7(text).p7(_Char___init__impl__6a9atx(10));
            this.l4z_1.o7('BODY END');
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(Logging$logRequestBody$slambda).m17 = function ($this$launch, completion) {
    var i = new Logging$logRequestBody$slambda(this.j4z_1, this.k4z_1, this.l4z_1, completion);
    i.m4z_1 = $this$launch;
    return i;
  };
  function Logging$logRequestBody$slambda_0($channel, $charset, $requestLog, resultContinuation) {
    var i = new Logging$logRequestBody$slambda($channel, $charset, $requestLog, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.l17($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function Logging$logRequestBody$lambda($logger, $requestLog) {
    return function (it) {
      $logger.f4x($requestLog.toString());
      $logger.j4x();
      return Unit_instance;
    };
  }
  function Logging$setupResponseLogging$slambda(this$0, resultContinuation) {
    this.y4z_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Logging$setupResponseLogging$slambda).f42 = function ($this$intercept, response, $completion) {
    var tmp = this.g42($this$intercept, response, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(Logging$setupResponseLogging$slambda).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.f42(tmp, p2 instanceof HttpResponse ? p2 : THROW_CCE(), $completion);
  };
  protoOf(Logging$setupResponseLogging$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 10;
            if (this.y4z_1.e4y_1.equals(LogLevel_NONE_getInstance()) || this.a50_1.h3x().p2i().r34(get_DisableLogging()))
              return Unit_instance;
            this.b50_1 = this.a50_1.h3x().p2i().p34(get_ClientCallLogger());
            this.c50_1 = StringBuilder_init_$Create$();
            this.d50_1 = false;
            this.j8_1 = 1;
            continue $sm;
          case 1:
            this.k8_1 = 4;
            this.k8_1 = 3;
            logResponseHeader(this.c50_1, this.a50_1.h3x().b3t(), this.y4z_1.e4y_1, this.y4z_1.g4y_1);
            this.j8_1 = 2;
            suspendResult = this.z4z_1.t3a(this.z4z_1.s3a(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp_0 = this;
            tmp_0.e50_1 = Unit_instance;
            this.k8_1 = 10;
            this.j8_1 = 7;
            continue $sm;
          case 3:
            this.k8_1 = 4;
            var tmp_1 = this.m8_1;
            if (tmp_1 instanceof Error) {
              this.f50_1 = this.m8_1;
              var tmp_2 = this;
              logResponseException(this.y4z_1, this.c50_1, this.a50_1.h3x().j3w(), this.f50_1);
              this.d50_1 = true;
              throw this.f50_1;
            } else {
              throw this.m8_1;
            }

          case 4:
            this.k8_1 = 10;
            this.g50_1 = this.m8_1;
            this.b50_1.g4x(this.c50_1.toString());
            if (this.d50_1 || !this.y4z_1.e4y_1.p4x_1) {
              this.j8_1 = 5;
              suspendResult = this.b50_1.k4x(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.j8_1 = 6;
              continue $sm;
            }

          case 5:
            this.j8_1 = 6;
            continue $sm;
          case 6:
            throw this.g50_1;
          case 7:
            this.k8_1 = 10;
            this.b50_1.g4x(this.c50_1.toString());
            if (this.d50_1 || !this.y4z_1.e4y_1.p4x_1) {
              this.j8_1 = 8;
              suspendResult = this.b50_1.k4x(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.j8_1 = 9;
              continue $sm;
            }

          case 8:
            this.j8_1 = 9;
            continue $sm;
          case 9:
            return Unit_instance;
          case 10:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 10) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(Logging$setupResponseLogging$slambda).g42 = function ($this$intercept, response, completion) {
    var i = new Logging$setupResponseLogging$slambda(this.y4z_1, completion);
    i.z4z_1 = $this$intercept;
    i.a50_1 = response;
    return i;
  };
  function Logging$setupResponseLogging$slambda_0(this$0, resultContinuation) {
    var i = new Logging$setupResponseLogging$slambda(this$0, resultContinuation);
    var l = function ($this$intercept, response, $completion) {
      return i.f42($this$intercept, response, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Logging$setupResponseLogging$slambda_1(this$0, resultContinuation) {
    this.p50_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Logging$setupResponseLogging$slambda_1).o3t = function ($this$intercept, it, $completion) {
    var tmp = this.p3t($this$intercept, it, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(Logging$setupResponseLogging$slambda_1).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.o3t(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(Logging$setupResponseLogging$slambda_1).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 6;
            if (this.p50_1.e4y_1.equals(LogLevel_NONE_getInstance()) || this.q50_1.p3b_1.p2i().r34(get_DisableLogging())) {
              return Unit_instance;
            }

            this.k8_1 = 3;
            this.j8_1 = 1;
            suspendResult = this.q50_1.u3a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.k8_1 = 6;
            this.j8_1 = 2;
            continue $sm;
          case 2:
            this.k8_1 = 6;
            return Unit_instance;
          case 3:
            this.k8_1 = 6;
            var tmp_0 = this.m8_1;
            if (tmp_0 instanceof Error) {
              this.s50_1 = this.m8_1;
              this.t50_1 = StringBuilder_init_$Create$();
              this.u50_1 = this.q50_1.p3b_1.p2i().p34(get_ClientCallLogger());
              logResponseException(this.p50_1, this.t50_1, this.q50_1.p3b_1.j3w(), this.s50_1);
              this.j8_1 = 4;
              suspendResult = this.u50_1.h4x(this.t50_1.toString(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 4:
            this.j8_1 = 5;
            suspendResult = this.u50_1.k4x(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            throw this.s50_1;
          case 6:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 6) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(Logging$setupResponseLogging$slambda_1).p3t = function ($this$intercept, it, completion) {
    var i = new Logging$setupResponseLogging$slambda_1(this.p50_1, completion);
    i.q50_1 = $this$intercept;
    i.r50_1 = it;
    return i;
  };
  function Logging$setupResponseLogging$slambda_2(this$0, resultContinuation) {
    var i = new Logging$setupResponseLogging$slambda_1(this$0, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.o3t($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Logging$setupResponseLogging$slambda_3(this$0, resultContinuation) {
    this.d51_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Logging$setupResponseLogging$slambda_3).w43 = function (it, $completion) {
    var tmp = this.x43(it, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(Logging$setupResponseLogging$slambda_3).m9 = function (p1, $completion) {
    return this.w43(p1 instanceof HttpResponse ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Logging$setupResponseLogging$slambda_3).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 10;
            if (this.d51_1.e4y_1.equals(LogLevel_NONE_getInstance()) || this.e51_1.h3x().p2i().r34(get_DisableLogging())) {
              return Unit_instance;
            }

            this.f51_1 = this.e51_1.h3x().p2i().p34(get_ClientCallLogger());
            this.g51_1 = StringBuilder_init_$Create$();
            this.j8_1 = 1;
            continue $sm;
          case 1:
            this.k8_1 = 4;
            this.k8_1 = 3;
            this.j8_1 = 2;
            suspendResult = logResponseBody(this.g51_1, contentType(this.e51_1), this.e51_1.k3w(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.h51_1 = suspendResult;
            this.k8_1 = 10;
            this.j8_1 = 7;
            continue $sm;
          case 3:
            this.k8_1 = 4;
            var tmp_0 = this.m8_1;
            if (tmp_0 instanceof Error) {
              this.i51_1 = this.m8_1;
              var tmp_1 = this;
              tmp_1.h51_1 = Unit_instance;
              this.k8_1 = 10;
              this.j8_1 = 7;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 4:
            this.k8_1 = 10;
            this.j51_1 = this.m8_1;
            this.j8_1 = 5;
            var this_0 = this.g51_1.toString();
            suspendResult = this.f51_1.i4x(toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE())), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.j8_1 = 6;
            suspendResult = this.f51_1.k4x(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            throw this.j51_1;
          case 7:
            this.k8_1 = 10;
            this.j8_1 = 8;
            var this_1 = this.g51_1.toString();
            suspendResult = this.f51_1.i4x(toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE())), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.j8_1 = 9;
            suspendResult = this.f51_1.k4x(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            return Unit_instance;
          case 10:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 10) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(Logging$setupResponseLogging$slambda_3).x43 = function (it, completion) {
    var i = new Logging$setupResponseLogging$slambda_3(this.d51_1, completion);
    i.e51_1 = it;
    return i;
  };
  function Logging$setupResponseLogging$slambda_4(this$0, resultContinuation) {
    var i = new Logging$setupResponseLogging$slambda_3(this$0, resultContinuation);
    var l = function (it, $completion) {
      return i.w43(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function Logging(logger, level, filters, sanitizedHeaders) {
    Companion_getInstance_0();
    filters = filters === VOID ? emptyList() : filters;
    this.d4y_1 = logger;
    this.e4y_1 = level;
    this.f4y_1 = filters;
    this.g4y_1 = sanitizedHeaders;
  }
  var properties_initialized_Logging_kt_588vu7;
  function _init_properties_Logging_kt__66pui5() {
    if (!properties_initialized_Logging_kt_588vu7) {
      properties_initialized_Logging_kt_588vu7 = true;
      ClientCallLogger = new AttributeKey('CallLogger');
      DisableLogging = new AttributeKey('DisableLogging');
    }
  }
  function logHeaders(_this__u8e3s4, headers, sanitizedHeaders) {
    // Inline function 'kotlin.collections.sortedBy' call
    var this_0 = toList(headers);
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = logHeaders$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
    var sortedHeaders = sortedWith(this_0, tmp$ret$0);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = sortedHeaders.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'io.ktor.client.plugins.logging.logHeaders.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var key = element.u();
      // Inline function 'kotlin.collections.component2' call
      var values = element.v();
      var tmp$ret$5;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator_0 = sanitizedHeaders.g();
        while (tmp0_iterator_0.h()) {
          var element_0 = tmp0_iterator_0.i();
          // Inline function 'io.ktor.client.plugins.logging.logHeaders.<anonymous>.<anonymous>' call
          if (element_0.i4y_1(key)) {
            tmp$ret$5 = element_0;
            break $l$block;
          }
        }
        tmp$ret$5 = null;
      }
      var tmp0_safe_receiver = tmp$ret$5;
      var placeholder = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h4y_1;
      logHeader(_this__u8e3s4, key, placeholder == null ? joinToString(values, '; ') : placeholder);
    }
  }
  function logHeader(_this__u8e3s4, key, value) {
    // Inline function 'kotlin.text.appendLine' call
    var value_0 = '-> ' + key + ': ' + value;
    // Inline function 'kotlin.text.appendLine' call
    _this__u8e3s4.f(value_0).p7(_Char___init__impl__6a9atx(10));
  }
  function logResponseHeader(log, response, level, sanitizedHeaders) {
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    if (level.n4x_1) {
      // Inline function 'kotlin.text.appendLine' call
      var value = 'RESPONSE: ' + response.u3n().toString();
      // Inline function 'kotlin.text.appendLine' call
      log.o7(value).p7(_Char___init__impl__6a9atx(10));
      // Inline function 'kotlin.text.appendLine' call
      var value_0 = 'METHOD: ' + response.h3x().j3w().i3x().toString();
      // Inline function 'kotlin.text.appendLine' call
      log.o7(value_0).p7(_Char___init__impl__6a9atx(10));
      // Inline function 'kotlin.text.appendLine' call
      var value_1 = 'FROM: ' + response.h3x().j3w().m3w().toString();
      // Inline function 'kotlin.text.appendLine' call
      log.o7(value_1).p7(_Char___init__impl__6a9atx(10));
    }
    if (level.o4x_1) {
      // Inline function 'kotlin.text.appendLine' call
      var value_2 = 'COMMON HEADERS';
      // Inline function 'kotlin.text.appendLine' call
      log.o7(value_2).p7(_Char___init__impl__6a9atx(10));
      logHeaders(log, response.p3i().n38(), sanitizedHeaders);
    }
  }
  function logResponseBody(log, contentType, content, $completion) {
    var tmp = new $logResponseBodyCOROUTINE$4(log, contentType, content, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.a52_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).pb = function (a, b) {
    return this.a52_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.pb(a, b);
  };
  function logHeaders$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'io.ktor.client.plugins.logging.logHeaders.<anonymous>' call
    var tmp = a.u();
    // Inline function 'io.ktor.client.plugins.logging.logHeaders.<anonymous>' call
    var tmp$ret$1 = b.u();
    return compareValues(tmp, tmp$ret$1);
  }
  function $logResponseBodyCOROUTINE$4(log, contentType, content, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s51_1 = log;
    this.t51_1 = contentType;
    this.u51_1 = content;
  }
  protoOf($logResponseBodyCOROUTINE$4).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 4;
            var tmp_0 = this;
            tmp_0.v51_1 = this.s51_1;
            var tmp_1 = this;
            tmp_1.w51_1 = this.v51_1;
            var this_0 = this.w51_1;
            var value = 'BODY Content-Type: ' + toString_0(this.t51_1);
            this_0.o7(value).p7(_Char___init__impl__6a9atx(10));
            var this_1 = this.w51_1;
            var value_0 = 'BODY START';
            this_1.o7(value_0).p7(_Char___init__impl__6a9atx(10));
            var tmp_2 = this;
            tmp_2.x51_1 = this.u51_1;
            var tmp_3 = this;
            var tmp0_safe_receiver = this.t51_1;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : charset(tmp0_safe_receiver);
            tmp_3.y51_1 = tmp1_elvis_lhs == null ? Charsets_getInstance().w30_1 : tmp1_elvis_lhs;
            this.k8_1 = 2;
            this.j8_1 = 1;
            suspendResult = this.x51_1.i2w(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.z51_1 = readText(ARGUMENT, this.y51_1);
            this.k8_1 = 4;
            this.j8_1 = 3;
            continue $sm;
          case 2:
            this.k8_1 = 4;
            var tmp_4 = this.m8_1;
            if (tmp_4 instanceof Error) {
              var cause = this.m8_1;
              var tmp_5 = this;
              tmp_5.z51_1 = null;
              this.j8_1 = 3;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 3:
            this.k8_1 = 4;
            var tmp2_elvis_lhs = this.z51_1;
            var message = tmp2_elvis_lhs == null ? '[response body omitted]' : tmp2_elvis_lhs;
            this.w51_1.o7(message).p7(_Char___init__impl__6a9atx(10));
            this.w51_1.o7('BODY END');
            return Unit_instance;
          case 4:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 4) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function observe(_this__u8e3s4, log, $completion) {
    var tmp = new $observeCOROUTINE$5(_this__u8e3s4, log, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  }
  function toReadChannel(_this__u8e3s4) {
    var tmp = GlobalScope_instance;
    var tmp_0 = Dispatchers_getInstance().nv_1;
    return writer(tmp, tmp_0, VOID, toReadChannel$slambda_0(_this__u8e3s4, null)).fw();
  }
  function toReadChannel$slambda($this_toReadChannel, resultContinuation) {
    this.v52_1 = $this_toReadChannel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(toReadChannel$slambda).f3y = function ($this$writer, $completion) {
    var tmp = this.g3y($this$writer, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(toReadChannel$slambda).m9 = function (p1, $completion) {
    return this.f3y((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(toReadChannel$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            this.j8_1 = 1;
            suspendResult = this.v52_1.b3o(this.w52_1.fw(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(toReadChannel$slambda).g3y = function ($this$writer, completion) {
    var i = new toReadChannel$slambda(this.v52_1, completion);
    i.w52_1 = $this$writer;
    return i;
  };
  function toReadChannel$slambda_0($this_toReadChannel, resultContinuation) {
    var i = new toReadChannel$slambda($this_toReadChannel, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.f3y($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $observeCOROUTINE$5(_this__u8e3s4, log, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j52_1 = _this__u8e3s4;
    this.k52_1 = log;
  }
  protoOf($observeCOROUTINE$5).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            this.l52_1 = this.j52_1;
            var tmp_0 = this.l52_1;
            if (tmp_0 instanceof ByteArrayContent) {
              this.j8_1 = 1;
              suspendResult = writeFully(this.k52_1, this.j52_1.w3n(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this.l52_1;
              if (tmp_1 instanceof ReadChannelContent) {
                var tmp_2 = this;
                var responseChannel = ByteChannel();
                var content = this.j52_1.z3n();
                copyToBoth(content, this.k52_1, responseChannel);
                tmp_2.m52_1 = new LoggedContent(this.j52_1, responseChannel);
                this.j8_1 = 2;
                continue $sm;
              } else {
                var tmp_3 = this.l52_1;
                if (tmp_3 instanceof WriteChannelContent) {
                  var tmp_4 = this;
                  var responseChannel_0 = ByteChannel();
                  var content_0 = toReadChannel(this.j52_1);
                  copyToBoth(content_0, this.k52_1, responseChannel_0);
                  tmp_4.m52_1 = new LoggedContent(this.j52_1, responseChannel_0);
                  this.j8_1 = 2;
                  continue $sm;
                } else {
                  var tmp_5 = this;
                  close(this.k52_1);
                  tmp_5.m52_1 = this.j52_1;
                  this.j8_1 = 2;
                  continue $sm;
                }
              }
            }

          case 1:
            close(this.k52_1);
            this.m52_1 = this.j52_1;
            this.j8_1 = 2;
            continue $sm;
          case 2:
            return this.m52_1;
          case 3:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function get_DEFAULT(_this__u8e3s4) {
    return get_SIMPLE(_this__u8e3s4);
  }
  //region block: init
  Companion_instance = new Companion();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = LogLevel_NONE_getInstance;
  _.$_$.b = Companion_getInstance_0;
  //endregion
  return _;
}));
